<script>
	import { caseExportEnabled, caseExportList } from "src/store/store";

	export let row;
	export let column;
	export let key;

	function onChange(caseNo) {
		caseExportList.update((list) => {
			if (list.includes(caseNo)) {
				return list.filter((item) => item !== caseNo);
			} else {
				return [...list, caseNo];
			}
		});
	}
</script>

<div class="d-flex">
	{#if $caseExportEnabled}
		<span>
			<input
				type="checkbox"
				name={key}
				aria-label="Select {row[key]}"
				on:change={() => onChange(row[key])}
			/>
		</span>
		&nbsp;
	{/if}
	<span>
		{row[key]}
	</span>
</div>
